module.exports = __webpack_public_path__ + "media/images/ac_templates/201/nvy-5da15905b0e355ed4ec65c44d203a3b1.jpg";